import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "15",
  fill: "none",
  viewBox: "0 0 21 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21 7.501 13.614 15l-1.355-1.376 5.071-5.15H0V6.528h17.33l-5.07-5.152L13.613 0 21 7.501Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }